module.exports = __webpack_public_path__ + "img/riseuplogo.67c73549.svg";